import IMAGES from './Images';

// eslint-disable-next-line import/prefer-default-export
export const DEFAULT_CONFIG = {
  faviconUrl: process.env.PUBLIC_URL
    ? `${process.env.PUBLIC_URL}/favicon.ico`
    : '/favicon.ico',
  companyLogo: IMAGES.DOSELECT_LOGO,
  companyLogoStyle: {},
  company64x64LOGO: IMAGES.DOSELECT_MARK_LOGO,
  companyDarkLogo: IMAGES.DOSELECT_DARK_LOGO,
  companySupportEmail: 'support@doselect.com',
  isSinglePageAssessmentStart: false,
  feedbackConfig: {
    heading: "Woot! You've completed this <%= assessmentType %>.",
    description:
      "We've notified team <%= displayByName %> about this. If you have any queries regarding this, please get in touch with your point of contact.",
  },
};
